<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th aria-hidden="true"></th>
                <th>{{ i18n._785_PERFORMER | translate }}</th>
                <th>{{ i18n._788_QUANTITY | translate }}</th>
                <th>{{ i18n._789_VIEW | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td
                    class="text-center"
                    aria-hidden="true"
                >
                    <cmps-icon
                        svgIcon="book-open-blank-variant"
                        *ngIf="
                            i.performerType ===
                            TeamCoachingPerformerType.WITH_GOALS
                        "
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="exclamation-thick"
                        *ngIf="
                            i.performerType ===
                            TeamCoachingPerformerType.NOT_MEETING_GOALS
                        "
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="check-circle-outline"
                        *ngIf="
                            i.performerType ===
                            TeamCoachingPerformerType.MEETING_GOALS
                        "
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="clock-outline"
                        *ngIf="
                            i.performerType ===
                            TeamCoachingPerformerType.OLD_GOALS
                        "
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="book-open-blank-variant-outline"
                        *ngIf="
                            i.performerType ===
                            TeamCoachingPerformerType.WITHOUT_GOALS
                        "
                    ></cmps-icon>
                </td>
                <td [ngSwitch]="i.performerType">
                    <span
                        *ngSwitchCase="TeamCoachingPerformerType.WITH_GOALS"
                        >{{ i18n._790_WITH_ACTIVE_JOURNALS | translate }}</span
                    >
                    <span
                        *ngSwitchCase="
                            TeamCoachingPerformerType.NOT_MEETING_GOALS
                        "
                        >{{ i18n._769_NOT_MEETING_GOAL | translate }}</span
                    >
                    <span
                        *ngSwitchCase="TeamCoachingPerformerType.MEETING_GOALS"
                        >{{ i18n._791_MEETING_GOAL | translate }}</span
                    >
                    <span *ngSwitchCase="TeamCoachingPerformerType.OLD_GOALS">{{
                        i18n._792_GOALS___30_DAYS | translate
                    }}</span>
                    <span
                        *ngSwitchCase="TeamCoachingPerformerType.WITHOUT_GOALS"
                        >{{ i18n._793_NO_ACTIVE_JOURNALS | translate }}</span
                    >
                </td>
                <td>{{ i.quantity }}</td>
                <td class="text-center">
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showDetails(i)"
                    >
                        <cmps-icon svgIcon="folder-outline"></cmps-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
